export default "__VITE_ASSET__34c879d0__"